import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';

import { BrowseButtonDetails } from './dropdown-options/interfaces/browse-button-details.interface';

@Component({
	selector: 'ac-filter-dropdown',
	templateUrl: './filter-dropdown.component.html',
	styleUrls: ['./filter-dropdown.component.scss']
})
export class FilterDropdownComponent implements OnInit, OnChanges {

	@Input() public dropdownItemsMap: Map<string, any[]>;
	@Input() public dropdownItems: Array<any>;
	@Input() public title: string;
	@Input() public searchDescription: string;
	@Input() public isGroupedDropdown: boolean;
	// Pass if you want to display a browse button at the bottom
	@Input() public browseButtonInformation: BrowseButtonDetails;
	@Input() public defaultSearchInput: string;
	@Input() private clearInputAfterSelection: boolean = false;
	@Output() public selectedObject = new EventEmitter();

	public searchInput: string;
	public filteredItems = [];
	public filteredItemsMap: Map<string, any[]>;
	public isDropdownHovered = false;
	public isInputFocused = false;

	constructor(
		protected contentService: ContentService
	) { }

	public ngOnInit(): void {
		this.filteredItems = this.dropdownItems;
		this.filteredItemsMap = new Map(this.dropdownItemsMap);
		this.searchInput = this.defaultSearchInput || '';
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.dropdownItemsMap) {
			this.filteredItemsMap = new Map(changes.dropdownItemsMap.currentValue);
		}
	}

	public searchInputChanged(input: string): void {
		if (this.isGroupedDropdown) {
			this.dropdownItemsMap.forEach((group, key) => {
				const filteredGroup = this.filterItems(group, input);
				this.filteredItemsMap.set(key, filteredGroup);
			});
		} else {
			this.filteredItems = this.filterItems(this.dropdownItems, input);
		}
	}

	public filterItems(items: Array<any>, input: string): Array<any> {
		return items?.filter(item => {
			const name = item._description || item.description || item._name || '';
			const nameLowCase = name.toLowerCase();
			const typedValueLowCase = input.toLowerCase();

			return nameLowCase.indexOf(typedValueLowCase) !== -1;
		}) ?? [];
	}

	public onSelection(item: any): void {
		this.searchInput = item.description;
		this.selectedObject.emit(item);
		this.isDropdownHovered = false;
		if (this.clearInputAfterSelection) {
			this.searchInput = '';
			this.searchInputChanged('');
		}
	}

	public onFocus(): void {
		this.isInputFocused = true;
	}
	public onBlur(): void {
		this.isInputFocused = false;
	}

	public onHover(event): void {
		this.isDropdownHovered = event;
	}
}
